export const jobLevels = [
  {
    level: 1,
    name: 'エントリー',
    description: '基礎知識を学んでいる（参考：~1年）'
  },
  {
    level: 2,
    name: 'ジュニア',
    description: 'サポートを受けながら実務ができる（参考：1~年）'
  },
  {
    level: 3,
    name: 'ミドル',
    description: '自律的に業務を遂行できる（参考：1、2~年）'
  },
  {
    level: 4,
    name: 'シニア',
    description: 'チームをリードできる（参考：3~年）'
  },
  {
    level: 5,
    name: 'エキスパート',
    description: '企業内でハイエンドと認められる（参考：5年〜）'
  }
];
